import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export const deletePaywall = async (communityId: string): Promise<void> => {
  if (!communityId) return;

  const paywallRef = firestore
    .collection(DB_PATH.COMMUNITY)
    .doc(communityId)
    .collection("landingPage")
    .doc("info");

  try {
    await paywallRef.delete();
  } catch (error) {
    console.error("Error deleting paywall", error);
  }
};
